<template>
  <span>{{ $t(keyTranslate) }}</span>
</template>
<script>
export default {
  name: 'translate-text',
  props: {
    keyTranslate: {
      type: String,
      required: true,
    },
  },
};
</script>
